import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import CheckboxInput from '../../common/components/checkbox-input'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import QuoteNumber from '../../common/components/quote-number'
import InputField from '../../common/components/input-field'
import SuburbAutoComplete from '../../common/components/suburb-auto-complete'
import checkOptions from '../../common/options/check-options'
import { toCurrency } from '../../common/util'
import { withConfig } from  '../../common/modules/config'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withState } from '../../common/modules/state'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { get } from 'lodash'


export const formConfig = step => {
    return {
        rules:{
            "requester.firstName":[
                Validation.enforce.required("Please enter a first name")
            ],
            "requester.surname":[
                Validation.enforce.required("Please enter a surname")
            ],
            "requester.email":[
                Validation.enforce.required("Please provide a valid email"),
                Validation.enforce.email("Must be a valid email")
            ],
            "requester.phone":[
                Validation.enforce.required("Please provide a valid phone number"),
            ],
            "postalAddress.deliveryPoint":[
                Validation.enforce.required("Please provide the billing address"),
            ],
            "postalAddress.suburb":[
                Validation.enforce.required("Please provide the suburb"),
            ],
            "postalAddress.postcode":[
                Validation.enforce.required("Please provide the postcode")
            ],
            "postalAddress.state":[
                Validation.enforce.required("Please provide the state"),
            ],
        },
        predicates:{},
        options:{
            useExistingAddress: checkOptions
        },
        inferred:{},
        transformOut: data => data,
    }
}



@withSubmission
@withNavigation
@withProductData
@withValidation
@withFields
@withRouteBlocker
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {


   private savedAddress = {
        "postalAddress.deliveryPoint":"",
        "postalAddress.suburb":"",
        "postalAddress.state":"",
        "postalAddress.postcode":""
    }


    componentWillMount(){
        const fields = this.props.fields;
        if(fields.useExistingAddress == null || fields.useExistingAddress == true){
            const deliveryPoint = get(fields, "ownersCorporationAddress.streetNumber") + " " + get(fields, "ownersCorporationAddress.streetName");
            const suburb = get(fields, "ownersCorporationAddress.suburb");
            const state = get(fields, "ownersCorporationAddress.state");
            const postcode = get(fields, "ownersCorporationAddress.postcode");
            
            this.props.actions.fields.updateField("postalAddress.deliveryPoint", deliveryPoint);
            this.props.actions.fields.updateField("postalAddress.suburb", suburb);
            this.props.actions.fields.updateField("postalAddress.state", state);
            this.props.actions.fields.updateField("postalAddress.postcode", postcode);
            this.props.actions.fields.updateField("useExistingAddress", true);
        }
    }


    intercept(field, value){
        const fields = this.props.fields;
        switch(field){
            case "useExistingAddress":
                const currentAddress = {
                    "postalAddress.deliveryPoint": get(fields, "postalAddress.deliveryPoint"),
                    "postalAddress.suburb": get(fields, "postalAddress.suburb"),
                    "postalAddress.state": get(fields, "postalAddress.state"),
                    "postalAddress.postcode": get(fields, "postalAddress.postcode")
                }

                this.props.actions.fields.updateFields(this.savedAddress)
                this.savedAddress = currentAddress;
            break;
        }
        return value;
    }


    render(){
        const fieldData = formConfig( this.props.state )
        const predicates = fieldData.predicates;
        const inferred = fieldData.inferred;
        const options = fieldData.options;

        const actions = this.props.actions;
        const fields = this.props.fields;
        const errors = this.props.errors;
         

        return (
            <div className="row">
                <StepBlock>
                    <p>We need a few additional details to complete your policy</p>
                </StepBlock>

                <StepTitle>Contact information</StepTitle>
                <QuoteNumber />

                <SubHeader>Your name</SubHeader>
                
                <InputField  field="requester.firstName"    label="First name"/>
                <InputField  field="requester.surname"      label="Surname"/>
                                

                <SubHeader>How can we contact you</SubHeader>

                <InputField  field="requester.phone"   type="tel"     label="Phone"   description="Please include area code if you're providing a landline e.g. 0298765432"/>
                <InputField  field="requester.email"   type="email"   label="Email"   description="This will allow us to forward you the quote and to retrieve it in the future." />
                

                <SubHeader>Billing Address</SubHeader>

                <StepBlock>
                    <p>We will try to get you your documents via email, however just in case, please tell me your billing address</p>
                </StepBlock>

                <InputField field="useExistingAddress"                    label="Same as insured address"                intercept={ this.intercept.bind(this) }/>
                <InputField field="postalAddress.deliveryPoint"           label="Billing Address" size="col-md-6"         enabled={ !fields.useExistingAddress }/>
                <div className="col-12"/>
                <InputField field="postalAddress.suburb"                  label="Suburb/Town"    size="col-md-6"         enabled={ !fields.useExistingAddress }  type="SuburbAuto"  stateField="postalAddress.state"  postcodeField="postalAddress.postcode"/>
                <InputField field="postalAddress.state"                   label="State"          size="col-3 col-md-3"   enabled={ false }/>
                <InputField field="postalAddress.postcode"                label="Postcode"       size="col-3 col-md-3"   enabled={ false } type="number"/>


                <Button.Container>
                    <Button.Continue onClick={ this.onContinue.bind(this)} />
                </Button.Container>

            </div>
        )
    }



    onContinue(){
        this.props.actions.validation.validate( this.submit.bind(this) )
    }


    submit(){
        const endpoint = this.props.submission.endpoints.finalise;
        this.props.actions.submission.submit(endpoint, this.proceed.bind(this), [
            require("./step-7").formConfig
        ])
    }


    proceed(){
        console.log("Proceed")
        this.props.actions.navigation.changeRoute("/payment");
    } 

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/routes/step-7.tsx